import { InvoiceFormReceiver } from '@features/invoices/types/invoiceForm/invoiceFormReceiver'
import { InvoicePayloadContact } from '@features/invoices/types/invoicePayload/invoicePayloadContact'
import { InvoiceCustomer } from '@features/invoices/types/invoices/invoiceCustomer'

import { getAgerasContactType } from '../getAgerasContactType'

export const getReceiverValues = (
  receiver: InvoicePayloadContact | InvoiceCustomer | undefined,
): InvoiceFormReceiver => {
  const {
    address,
    businessId,
    customerNumber,
    customerType,
    displayName,
    eInvoiceAddress,
    externalContactId,
    paymentTerm,
    phoneNumberWork,
    vatNumber,
  } = receiver || {}

  let id
  const isCustomer = !!receiver && 'customerId' in receiver
  if (receiver) {
    if (isCustomer) {
      id = receiver.customerId
    } else if ('id' in receiver) {
      id = receiver?.id
    }
  }

  return {
    // streetAddress2/email/isPublicEntity exist on both source shapes but were previously
    // dropped from the form receiver. Hydrating them here keeps full-document write-back
    // flows (QuoteEdit) from silently wiping persisted values. Scoped to the customer
    // (GET-response) branch to leave draft-payload flows behaviourally unchanged.
    ...(isCustomer && {
      addressLine2: receiver.address?.streetAddress2 ?? null,
      email: receiver.email ?? '',
      publicEntityRoutingEnabled: receiver.isPublicEntity,
    }),
    cityText: address?.city || '',
    contactNo: String(customerNumber),
    countryId: address?.country || '',
    ean: eInvoiceAddress?.address || '',
    eInvoiceScheme: eInvoiceAddress?.scheme || '',
    externalId: String(id),
    id: externalContactId || '',
    name: String(displayName),
    paymentTermsDays: paymentTerm,
    phone: phoneNumberWork || '',
    registrationNo: String(businessId),
    street: address?.streetAddress1 || '',
    type: getAgerasContactType(customerType),
    vatNo: vatNumber || '',
    zipcodeText: address?.pobox || '',
  }
}
